// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import useIntl from '../../../../../hooks/useIntl';
import messages from './messages';

type Props = {
  open: boolean,
  onClose: () => void,
};

function MigrationStartedModal({ open, onClose }: Props) {
  const intl = useIntl();

  return (
    <Modal
      open={open}
      onClose={onClose}
      status="info"
      icon={<AlertInfoIcon />}
      title={intl.formatMessage(messages.startedTitle)}
      actions={
        <Button variant="primary" onClick={onClose}>
          <FormattedMessage {...messages.gotIt} />
        </Button>
      }
    >
      <Stack spacing={2}>
        <Typography variant="bodyMedium">
          <FormattedMessage {...messages.startedSaved} />
        </Typography>
        <Typography variant="bodyMedium">
          <FormattedMessage {...messages.startedMigrating} />
        </Typography>
        <Typography variant="bodyMedium">
          <FormattedMessage {...messages.startedUsable} />
        </Typography>
      </Stack>
    </Modal>
  );
}

export default MigrationStartedModal;
